<img [src]="image"class="img-fluid w-100">